<template>
    <div>
        <el-descriptions style='margin-bottom: 2rem' title='Class访问权限' direction='horizontal' :column='1'
                         border>
            <template #extra>
                <el-button type='primary' @click='handleUpdatePermission("clp")'>修 改</el-button>
            </template>
            <el-descriptions-item :key='key' v-for='(value, key) in classPermissionInfo.classLevelPermissionMap'
                                  :label='key'>
                <span>{{ computePermissionSummary(value) }}</span>
            </el-descriptions-item>
        </el-descriptions>
        
        <el-descriptions style='margin-bottom: 2rem' title='默认ACL权限' direction='horizontal' :column='1'
                         border>
            <template #extra>
                <el-button type='primary' @click='handleUpdatePermission("defaultACL")'>修 改</el-button>
            </template>
            <el-descriptions-item :key='key' v-for='(value, key) in classPermissionInfo.defaultACL'
                                  :label='key'>
                <span>{{ computePermissionSummary(value) }}</span>
            </el-descriptions-item>
        </el-descriptions>
        
        <el-card class='box-card' shadow='never'>
            <div slot='header' class='clearfix'>
                <h4>列访问权限</h4>
            </div>
            <ul>
                <li class='permissionLi' v-if='key !== "objectId"'
                    v-for='(item, key) in classPermissionInfo.protectedOptionMap'
                    :key='key'>
                    <el-row :gutter='20'>
                        <el-col :span='8'>
                            {{ key }}
                        </el-col>
                        <el-col :span='16'>
                            <el-checkbox @change='handleProtectedFieldChange($event, true, key)'
                                         v-model='item.clientHidden'>客户端隐藏
                            </el-checkbox>
                            <el-checkbox v-if='!item.hiddenReadOnly' :disabled='item.disableReadOnly'
                                         @change='handleProtectedFieldChange($event, false, key)'
                                         v-model='item.readOnly'>只读
                            </el-checkbox>
                        </el-col>
                    </el-row>
                </li>
            </ul>
        </el-card>
        
        <el-card class='box-card' shadow='never'>
            <div slot='header' class='clearfix'>
                <h4>列访问权限</h4>
            </div>
            <ul>
                <li class='permissionLi'>
                    <el-row :gutter='20'>
                        <el-col :span='8'>
                            查询结果包含ACL
                        </el-col>
                        <el-col :span='16'>
                            <el-switch
                                v-model='applicationClassConfig.allowQueryResultContainAclField'
                                active-color='#13ce66'
                                @change='updateSwitchConfig($event, "allowQueryResultContainAclField")'
                                inactive-color='#ff4949'>
                            </el-switch>
                        </el-col>
                    </el-row>
                </li>
                
                <li class='permissionLi'>
                    <el-row :gutter='20'>
                        <el-col :span='8'>
                            查询结果包含CreateUserId
                        </el-col>
                        <el-col :span='16'>
                            <el-switch
                                v-model='applicationClassConfig.allowQueryResultContainCreateUserIdField'
                                active-color='#13ce66'
                                @change='updateSwitchConfig($event, "allowQueryResultContainCreateUserIdField")'
                                inactive-color='#ff4949'>
                            </el-switch>
                        </el-col>
                    </el-row>
                </li>
                
                <li class='permissionLi'>
                    <el-row :gutter='20'>
                        <el-col :span='8'>
                            查询结果包含UpdateUserId
                        </el-col>
                        <el-col :span='16'>
                            <el-switch
                                v-model='applicationClassConfig.allowQueryResultContainUpdateUserIdField'
                                active-color='#13ce66'
                                @change='updateSwitchConfig($event, "allowQueryResultContainUpdateUserIdField")'
                                inactive-color='#ff4949'>
                            </el-switch>
                        </el-col>
                    </el-row>
                </li>
            </ul>
        </el-card>
        
        <el-dialog title='Class访问权限编辑' :close-on-click-modal='true' :close-on-press-escape='true'
                   :show-close='false'
                   :visible.sync='openCLPEdit' width='40%'>
            <class-acl :all-access-info='currentAccessInfo.allAccessInfo'
                       :permission-list='currentAccessInfo.permissionList'
                       :show-data-creator-setting='false'
                       @cancelAccessInfoSetting='handleCancelCLPAccessInfoSetting'
                       @getAccessInfo='handleGetCLPAccessInfo'
                       :app-id='appId' />
        </el-dialog>
        
        <el-dialog title='默认权限编辑' :close-on-click-modal='true' :close-on-press-escape='true' :show-close='false'
                   :visible.sync='openDefaultACPEdit' width='40%'>
            <class-acl :all-access-info='currentAccessInfo.allAccessInfo'
                       :show-authenticated-user-setting='false'
                       :show-data-creator='true'
                       @cancelAccessInfoSetting='handleCancelACLAccessInfoSetting'
                       @getAccessInfo='handleGetACLAccessInfo'
                       :app-id='appId' />
        </el-dialog>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { deepCopy } from '@/utils/object';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import { message } from '@/utils/message';
import ClassAcl from '@/components/component/storage/ClassAcl.vue';
import { packageACLInfo, packageACLParam } from '@/utils/storage';
import { applicationConfigApi } from '@api/Storage/applicaitonConfig';

export default defineComponent({
    name: 'DataPermissionSetting',
    components: { ClassAcl },
    data() {
        return {
            openCLPEdit: false,
            openDefaultACPEdit: false,
            currentAccessInfo: {},
            baseFieldNameList: ['ACL', 'createdAt', 'updatedAt'],
            classPermissionInfo: {
                classLevelPermissionMap: {},
                protectedOptionMap: {},
                defaultACL: {
                    read: {
                        requiresAuthentication: undefined,
                        allowAll: undefined,
                        roleAuthenticationMap: [],
                        userAuthenticationMap: []
                    },
                    write: {
                        requiresAuthentication: undefined,
                        allowAll: undefined,
                        roleAuthenticationMap: [],
                        userAuthenticationMap: []
                    }
                },
                
                classLevelPermissionFieldList: [],
                defaultACLFieldList: [],
                classLevelPermissionAccessInfo: {},
                defaultACLAccessInfo: {}
            },
            schemaInfoTemp: {},
            applicationClassConfig: {}
        };
    },
    props: {
        appId: {
            type: String
        },
        className: {
            type: String
        }
    },
    created() {
        this.reloadSchemaInfo();
    },
    computed: {
        computePermissionSummary() {
            return value => {
                if (value.allowAll && value.allowAll === true) {
                    return '所有用户';
                } else if (value.requiresAuthentication && value.requiresAuthentication === true) {
                    return '认证用户';
                } else if (value.dataCreator && value.dataCreator === true) {
                    return '数据创建者';
                } else {
                    let userAuthenticationMap = value.userAuthenticationMap;
                    let roleAuthenticationMap = value.roleAuthenticationMap;
                    let userCount = 0;
                    let roleCount = 0;
                    if (userAuthenticationMap) {
                        userCount = userAuthenticationMap.length;
                    }
                    if (roleAuthenticationMap) {
                        roleCount = roleAuthenticationMap.length;
                    }
                    let msg = '';
                    if (userCount > 0) {
                        msg = msg + '用户: ' + userCount + ' ';
                    }
                    if (roleCount > 0) {
                        msg = msg + '角色: ' + roleCount;
                    }
                    return msg;
                }
            };
        }
    },
    methods: {
        reloadSchemaInfo() {
            storageSchemaApi.querySingleSchema(this.className, this.appId).then(result => {
                if (result.code === 200) {
                    this.schemaInfoTemp = result.data;
                    this.initClassPermissionInfo();
                }
            });
            
            this.applicationClassConfig = {};
            applicationConfigApi.queryConfigList(this.appId, { className: this.className }).then(result => {
                if (result.code === 200) {
                    let data = result.data;
                    this.applicationClassConfig = data.class;
                    if (!this.applicationClassConfig) {
                        this.applicationClassConfig = {};
                    }
                }
            });
        },
        handleUpdatePermission(operate) {
            if (operate === 'defaultACL') {
                this.currentAccessInfo.allAccessInfo = this.classPermissionInfo.defaultACLAccessInfo;
                this.openDefaultACPEdit = true;
            } else {
                this.currentAccessInfo.allAccessInfo = this.classPermissionInfo.classLevelPermissionAccessInfo;
                this.openCLPEdit = true;
            }
        },
        handleProtectedFieldChange(value, isClientHidden, fieldName) {
            let schemaInfo = deepCopy(this.schemaInfoTemp);
            if (!schemaInfo.protectedOption) {
                schemaInfo.protectedOption = {};
            }
            if (!schemaInfo.protectedOption[fieldName]) {
                schemaInfo.protectedOption[fieldName] = {};
            }
            
            schemaInfo.protectedOption[fieldName]['fieldName'] = fieldName;
            if (isClientHidden) {
                schemaInfo.protectedOption[fieldName]['clientHidden'] = value;
            } else {
                schemaInfo.protectedOption[fieldName]['readOnly'] = value;
            }
            storageSchemaApi.updateSchema(this.className, schemaInfo, this.appId).then(result => {
                if (result.code === 200) {
                    message.success(result.message);
                }
            });
        },
        handleCancelCLPAccessInfoSetting() {
            this.openCLPEdit = false;
            this.reloadSchemaInfo();
        },
        async initClassPermissionInfo() {
            this.classPermissionInfo = {
                classLevelPermissionMap: {},
                protectedOptionMap: {},
                defaultACL: {
                    read: {
                        requiresAuthentication: undefined,
                        allowAll: undefined,
                        dataCreator: undefined,
                        roleAuthenticationMap: [],
                        userAuthenticationMap: []
                    },
                    write: {
                        requiresAuthentication: undefined,
                        allowAll: undefined,
                        dataCreator: undefined,
                        roleAuthenticationMap: [],
                        userAuthenticationMap: []
                    }
                },
                
                classLevelPermissionFieldList: [],
                classLevelPermissionAccessInfo: {},
                
                defaultACLFieldList: [],
                defaultACLAccessInfo: {}
            };
            // 获取类级别权限信息
            let metadata = this.schemaInfoTemp.metadata;
            
            this.classPermissionInfo.classLevelPermissionMap = this.schemaInfoTemp.classLevelPermission;
            this.classPermissionInfo.protectedOptionMap = this.schemaInfoTemp.protectedOption;
            
            if (metadata && metadata.default_acp) {
                let defaultACP = metadata.default_acp;
                this.classPermissionInfo.defaultACL = await packageACLParam(defaultACP);
            }
            if (!this.classPermissionInfo.protectedOptionMap) {
                this.classPermissionInfo.protectedOptionMap = {};
            }
            let fieldOptions = this.schemaInfoTemp.fieldOption;
            if (fieldOptions) {
                let keyArr = Object.keys(fieldOptions);
                keyArr.forEach((key, index) => {
                    if (!this.classPermissionInfo.protectedOptionMap[key]) {
                        this.classPermissionInfo.protectedOptionMap[key] = {
                            clientHidden: undefined,
                            readOnly: undefined
                        };
                    }
                });
            }
            
            // 增加默认
            this.baseFieldNameList.forEach(t => {
                if (!this.classPermissionInfo.protectedOptionMap[t]) {
                    this.classPermissionInfo.protectedOptionMap[t] = {
                        clientHidden: undefined,
                        readOnly: undefined
                    };
                }
            });
            
            // 设置参数
            for (let key in this.classPermissionInfo.classLevelPermissionMap) {
                this.classPermissionInfo.classLevelPermissionFieldList.push(key);
                
                this.classPermissionInfo.classLevelPermissionAccessInfo[key] = this.classPermissionInfo.classLevelPermissionMap[key];
            }
            
            for (let key in this.classPermissionInfo.defaultACL) {
                this.classPermissionInfo.defaultACLFieldList.push(key);
                
                this.classPermissionInfo.defaultACLAccessInfo[key] = this.classPermissionInfo.defaultACL[key];
            }
            
            for (let fieldName in this.classPermissionInfo.protectedOptionMap) {
                if (fieldName === 'createdAt' || fieldName === 'updatedAt'
                    || fieldName === 'createUserId' || fieldName === 'updateUserId') {
                    this.classPermissionInfo.protectedOptionMap[fieldName]['hiddenReadOnly'] = true;
                }
            }
        },
        handleGetCLPAccessInfo(accessInfo) {
            let schemaInfo = deepCopy(this.schemaInfoTemp);
            schemaInfo.classLevelPermission = accessInfo;
            storageSchemaApi.updateSchema(this.className, schemaInfo, this.appId).then(result => {
                if (result.code === 200) {
                    message.success(result.message);
                    this.openCLPEdit = false;
                    this.reloadSchemaInfo();
                }
            });
        },
        handleCancelACLAccessInfoSetting() {
            this.openDefaultACPEdit = false;
        },
        
        /**
         * acl的格式为{"role or user or *": {read: true, write: true}}
         * @param accessInfo
         */
        handleGetACLAccessInfo(accessInfo) {
            packageACLInfo(accessInfo).then(defaultACLInfo => {
                let schemaInfo = deepCopy(this.schemaInfoTemp);
                let metadata = schemaInfo.metadata;
                if (!metadata) {
                    metadata = {};
                }
                metadata.default_acp = defaultACLInfo;
                schemaInfo.metadata = metadata;
                storageSchemaApi.updateSchema(this.className, schemaInfo, this.appId).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                        this.openDefaultACPEdit = false;
                        this.reloadSchemaInfo();
                    }
                });
            });
        },
        updateSwitchConfig(value, key) {
            let configKey = `${this.className}.${key}`;
            applicationConfigApi.updateConfig({
                key: configKey,
                value: value
            }, this.appId).then(result => {
                if (result.code === 200) {
                    message.success(result.message);
                }
            });
        }
    }
});
</script>

<style scoped lang='scss'>

</style>
